export const immunitiesData = {
  'Abaddon': {
    'Cold': [
      'Hell Lord',
      'Hell Witch',
      'Lasher'
    ],
    'Fire': [
      'Balrog',
      'Demon Imp',
      'Demon Rascal',
      'Fire Boar'
    ],
    'Lightning': [
      'Strangler'
    ],
    'Physical': [
      'Blood Lord'
    ],
    'Poison': [
      'Balrog',
      'Horror Archer',
      'Undead Flayer'
    ]
  },
  'Ancient_Tunnels': {
    'Fire': [
      'Invader'
    ],
    'Lightning': [
      'Horror Lightning Mage'
    ],
    'Magic': [
      'Plague Bearer'
    ],
    'Poison': [
      'Embalmed'
    ]
  },
  'Arachnid_Lair': {
    'Fire': [
      'link= Flame Spider}'
    ],
    'Lightning': [
      'Fiend'
    ],
    'Poison': [
      'Giant Lamprey Young',
      'Giant Lamprey',
      'Poison Spinner'
    ]
  },
  'Arcane_Sanctuary': {
    'Cold': [
      'Ghoul Lord'
    ],
    'Fire': [
      'Hell Clan'
    ],
    'Lightning': [
      'Lightning Spire'
    ],
    'Physical': [
      'Specter'
    ],
    'Poison': [
      'Lightning Spire'
    ]
  },
  'Arreat_Plateau': {
    'Cold': [
      'Death Slasher',
      'Fire Boar',
      'Hell Whip',
      'Lasher',
      'Night Clan'
    ],
    'Fire': [
      'Consumed Fire Boar',
      'Demon Gremlin',
      'Fanatic Enslaved',
      'Returned Fire Mage',
      'Siege Beast',
      'Slayer'
    ],
    'Lightning': [
      'Returned Lightning Mage'
    ],
    'Poison': [
      'Returned Fire Mage',
      'Returned Lightning Mage',
      'Spear Cat'
    ]
  },
  'Arreat_Summit': {
    'Cold': [
      'Korlic'
    ],
    'Fire': [
      'Talic'
    ],
    'Lightning': [
      'Madawc'
    ]
  },
  'Barracks': {
    'Cold': [
      'Black Rogue'
    ],
    'Fire': [
      'Bone Fire Mage',
      'Devilkin Shaman',
      'Devilkin'
    ],
    'Poison': [
      'Bone Archer'
    ]
  },
  'Black_Marsh': {
    'Cold': [
      'Brute'
    ],
    'Fire': [
      'Carver Shaman',
      'Carver',
      'Vile Archer'
    ],
    'Lightning': [
      'Night Clan'
    ],
    'Poison': [
      'Blood Hawk',
      'Returned'
    ]
  },
  'Bloody_Foothills': {
    'Cold': [
      'Enslaved',
      'Fanatic Enslaved',
      'Foul Crow',
      'Overseer'
    ],
    'Fire': [
      'Demon Imp',
      'Quill Rat',
      'Slinger'
    ],
    'Lightning': [
      'Death Mauler',
      'Thorned Hulk'
    ],
    'Poison': [
      'Burning Dead Archer',
      'Carrion Bird',
      'Foul Crow'
    ]
  },
  'Blood_Moor': {
    'Cold': [
      'Zombie'
    ],
    'Fire': [
      'Fallen'
    ]
  },
  'Burial_Grounds': {
    'Lightning': [
      'Hungry Dead',
      'Skeleton'
    ]
  },
  'Canyon_of_the_Magi': {
    'Cold': [
      'Crusher',
      'Hell Cat'
    ],
    'Fire': [
      'Hell Slinger'
    ],
    'Lightning': [
      'Steel Scarab'
    ],
    'Poison': [
      'Devourer',
      'link = Devourer Young'
    ]
  },
  'Catacombs': {
    'Cold': [
      'The Banished'
    ],
    'Fire': [
      'Arach',
      'Dark One',
      'Dark Shaman',
      'Ghoul',
      'Rat Man'
    ],
    'Lightning': [
      'Afflicted',
      'Tainted'
    ]
  },
  'Cathedral': {
    'Cold': [
      'Bone Ash'
    ],
    'Fire': [
      'Dark One',
      'Dark Shaman'
    ],
    'Lightning': [
      'Tainted'
    ],
    'Physical': [
      'Wraith'
    ]
  },
  'Cave': {
    'Lightning': [
      'Coldcrow',
      'Dark Ranger',
      'Hungry Dead',
      'Skeleton'
    ]
  },
  'Chaos_Sanctuary': {
    'Cold': [
      'Lord de Seis',
      'Oblivion Knight'
    ],
    'Fire': [
      'Doom Knight',
      'Infector of Souls',
      'Venom Lord'
    ],
    'Lightning': [
      'Grand Vizier of Chaos',
      'Storm Caster'
    ],
    'Poison': [
      'Infector of Souls',
      'Venom Lord'
    ]
  },
  'Chaos_Tristram': {
    'Cold': [
      'Baal Hell',
      'Balrog'
    ],
    'Fire': [
      'Balrog',
      'Diablo Hell'
    ],
    'Lightning': [
      'Balrog',
      'Mephisto Hell'
    ],
    'Magic': [
      'Balrog'
    ],
    'Poison': [
      'Balrog',
      'Mephisto Hell'
    ]
  },
  'City_of_the_Damned': {
    'Cold': [
      'Stygian Dog',
      'Stygian Hag'
    ],
    'Fire': [
      'Pit Lord'
    ],
    'Lightning': [
      'Abyss Knight',
      'Damned',
      'Dark Familiar',
      'Strangler'
    ],
    'Poison': [
      'Corpse Spitter'
    ]
  },
  'Claw_Viper_Temple': {
    'Cold': [
      'Bone Warrior',
      'Claw Viper',
      'Fangskin',
      'Salamander'
    ],
    'Fire': [
      'Guardian'
    ],
    'Magic': [
      'Guardian'
    ],
    'Poison': [
      'Embalmed'
    ]
  },
  'Cold_Plains': {
    'Cold': [
      'Corrupt Rogue',
      'Gargantuan Beast'
    ],
    'Fire': [
      'Bishibosh',
      'Dark Spearwoman',
      'Fallen Shaman',
      'Fallen'
    ]
  },
  'Crypt': {
    'Lightning': [
      'Bonebreaker',
      'Hungry Dead',
      'Skeleton'
    ]
  },
  'Crystalline_Passage': {
    'Cold': [
      'Abominable',
      'Bone Cold Mage',
      'Cave Leaper',
      'Dark Archer',
      'Frozen Horror',
      'Marauder'
    ],
    'Fire': [
      'Moon Lord',
      'Succubus'
    ],
    'Lightning': [
      'Stygian Harlot'
    ],
    'Physical': [
      'Blood Lord',
      'Ghost'
    ],
    'Poison': [
      'Bone Cold Mage',
      'Ghost'
    ]
  },
  'Dark_Wood': {
    'Cold': [
      'Brute',
      'Treehead Woodfist',
      'Vile Hunter'
    ],
    'Fire': [
      'Carver',
      'Vile Lancer'
    ],
    'Poison': [
      'Skeleton Archer'
    ]
  },
  'Den_of_Evil': {
    'Cold': [
      'Corpsefire',
      'Gargantuan Beast',
      'Zombie'
    ],
    'Fire': [
      'Fallen Shaman',
      'Fallen'
    ]
  },
  'Disused_Fane': {
    'Cold': [
      'Flesh Hunter',
      'Night Lord 2'
    ],
    'Fire': [
      'Spider Magi'
    ],
    'Magic': [
      'Wailing Beast'
    ]
  },
  'Disused_Reliquary': {
    'Cold': [
      'Flesh Archer',
      'Serpent Magus'
    ],
    'Fire': [
      'Blood Diver'
    ],
    'Lightning': [
      'Bone Scarab'
    ]
  },
  'Drifter_Cavern': {
    'Cold': [
      'Abominable',
      'Bone Cold Mage',
      'Dark Archer',
      'Frozen Horror',
      'Marauder',
      'Night Clan'
    ],
    'Fire': [
      'Blood Lord'
    ],
    'Lightning': [
      'Misshapen',
      'Stygian Harlot'
    ],
    'Physical': [
      'Ghost'
    ],
    'Poison': [
      'Bone Cold Mage',
      'Ghost',
      'Vile Temptress'
    ]
  },
  'Dry_Hills': {
    'Cold': [
      'Cave Leaper'
    ],
    'Fire': [
      'Sabre Cat'
    ],
    'Lightning': [
      'Undead Scavenger'
    ]
  },
  'Durance_of_Hate': {
    'Cold': [
      'Blood Lord 2',
      'Dark Lord'
    ],
    'Lightning': [
      'Council Member',
      'Mauler'
    ],
    'Poison': [
      'Cadaver',
      'Undead Stygian Doll'
    ]
  },
  'Far_Oasis': {
    'Lightning': [
      'Beetleburst',
      'Death Beetle',
      'Undead Scavenger'
    ],
    'Physical': [
      'Itchies'
    ],
    'Poison': [
      'Black Raptor',
      'Sand Maggot Young',
      'Sand Maggot'
    ]
  },
  'Flayer_Dungeon': {
    'Cold': [
      'Flayer',
      'Gloombat'
    ],
    'Fire': [
      'Flayer Shaman',
      'Soul Killer Shaman',
      'Witch Doctor Endugu'
    ],
    'Lightning': [
      'Soul Killer'
    ],
    'Physical': [
      'Dark Shape'
    ],
    'Poison': [
      'Undead Flayer'
    ]
  },
  'Flayer_Jungle': {
    'Cold': [
      'Flayer',
      'Stormtree',
      'Thrasher'
    ],
    'Fire': [
      'Flayer Shaman',
      'Soul Killer Shaman'
    ],
    'Lightning': [
      'Soul Killer',
      'Winged Nightmare'
    ],
    'Poison': [
      'Slime Prince'
    ]
  },
  'Forgotten_Reliquary': {
    'Cold': [
      'Flesh Hunter',
      'Night Lord 2'
    ],
    'Fire': [
      'Spider Magi'
    ],
    'Magic': [
      'Wailing Beast'
    ]
  },
  'Forgotten_Sands': {
    'Fire': [
      'Arach'
    ],
    'Lightning': [
      'Blood Maggot',
      'Dung Soldier'
    ],
    'Physical': [
      'Hell Swarm'
    ],
    'Poison': [
      'Blood Maggot Young',
      'Blood Maggot'
    ]
  },
  'Forgotten_Temple': {
    'Cold': [
      'Flesh Archer',
      'Serpent Magus'
    ],
    'Fire': [
      'Blood Diver'
    ],
    'Lightning': [
      'Bone Scarab'
    ]
  },
  'Forgotten_Tower': {
    'Cold': [
      'Dark Stalker',
      'The Countess'
    ],
    'Fire': [
      'Blood Clan',
      'Devilkin'
    ],
    'Lightning': [
      'Dark Archer'
    ],
    'Physical': [
      'Ghost'
    ]
  },
  'Frigid_Highlands': {
    'Cold': [
      'Eldritch the Rectifier',
      'Enslaved',
      'Lasher',
      'Sharptooth Slayer',
      'Spear Cat'
    ],
    'Fire': [
      'Demon Gremlin',
      'Demon Imp',
      'Demon Rascal',
      'Fanatic Enslaved',
      'Siege Beast',
      'Slayer',
      'Vile Archer'
    ],
    'Lightning': [
      'Death Brawler',
      'Death Mauler',
      'Eyeback the Unleashed',
      'Vile Lancer'
    ],
    'Poison': [
      'Burning Dead Archer'
    ]
  },
  'Frozen_River': {
    'Cold': [
      'Abominable',
      'Blood Witch',
      'Bone Cold Mage',
      'Death Slasher',
      'Frozen Horror',
      'Reanimated Horde'
    ],
    'Fire': [
      'Moon Lord'
    ],
    'Lightning': [
      'Dark Lancer',
      'Gloam'
    ],
    'Physical': [
      'Ghost'
    ],
    'Poison': [
      'Blood Temptress',
      'Bone Cold Mage',
      'Ghost',
      'Gloam'
    ]
  },
  'Frozen_Tundra': {
    'Cold': [
      'Death Clan'
    ],
    'Fire': [
      'Demon Rascal',
      'Hell Spawn',
      'Siege Beast'
    ],
    'Lightning': [
      'Returned Lightning Mage'
    ],
    'Physical': [
      'Death Berserker'
    ],
    'Poison': [
      'Bone Archer',
      'Carrion Bird',
      'Returned Lightning Mage'
    ]
  },
  'Furnace_of_Pain': {
    'Cold': [
      'Balrog',
      'Hell Whip',
      'Oblivion Knight'
    ],
    'Fire': [
      'Balrog',
      'Doom Knight',
      'Hell Spawn'
    ],
    'Lightning': [
      'Balrog'
    ],
    'Magic': [
      'Balrog'
    ],
    'Poison': [
      'Balrog'
    ]
  },
  'Glacial_Trail': {
    'Cold': [
      'Abominable',
      'Bone Cold Mage',
      'Death Slasher',
      'Frozen Horror',
      'Reanimated Horde',
      'Serpent Magus'
    ],
    'Fire': [
      'Blood Lord'
    ],
    'Lightning': [
      'Bone Warrior',
      'Fiend'
    ],
    'Physical': [
      'Ghost'
    ],
    'Poison': [
      'Bone Cold Mage',
      'Bone Warrior',
      'Ghost',
      'Serpent Magus'
    ]
  },
  'Great_Marsh': {
    'Cold': [
      'Bog Creature',
      'Bramble Hulk'
    ],
    'Fire': [
      'Drowned Carcass',
      'Fetish Shaman',
      'Swamp Dweller'
    ],
    'Lightning': [
      'Fetish',
      'Gloam'
    ]
  },
  'Halls_of_Anguish': {
    'Cold': [
      'Death Brigadier',
      'Reanimated Horde',
      'Tree Lurker'
    ],
    'Fire': [
      'Fetish'
    ],
    'Lightning': [
      'Night Lord',
      'Returned',
      'Scarab',
      'Temple Guard'
    ],
    'Poison': [
      'Returned'
    ]
  },
  'Halls_of_Pain': {
    'Cold': [
      'Reanimated Horde'
    ],
    'Lightning': [
      'Death Brawler'
    ],
    'Poison': [
      'Putrid Defiler',
      'Reanimated Horde'
    ]
  },
  'Halls_of_the_Dead': {
    'Cold': [
      'Bloodwitch the Wild',
      'Huntress',
      'Spear Cat'
    ],
    'Fire': [
      'Desert Wing'
    ],
    'Lightning': [
      'Hollow One'
    ],
    'Poison': [
      'Decayed',
      'Returned'
    ]
  },
  'Halls_of_Vaught': {
    'Cold': [
      'Ice Spawn',
      'Reanimated Horde',
      'Slayer'
    ],
    'Fire': [
      'Arach',
      'Fetish Shaman',
      'Fetish'
    ],
    'Lightning': [
      'Claw Viper'
    ],
    'Physical': [
      'Dune Beast',
      'Ghost'
    ],
    'Poison': [
      'Claw Viper',
      'Dune Beast',
      'Ghost',
      'Putrid Defiler',
      'Returned Archer',
      'Wretched Defiler'
    ]
  },
  'Harem': {
    'Cold': [
      'Horror Cold Mage'
    ],
    'Fire': [
      'Blunderbore',
      'Invader'
    ],
    'Lightning': [
      'Dune Beast'
    ],
    'Poison': [
      'Horror Archer'
    ]
  },
  'Hole': {
    'Cold': [
      'Brute'
    ],
    'Fire': [
      'Carver'
    ],
    'Lightning': [
      'Misshapen',
      'Vile Archer'
    ]
  },
  'Icy_Cellar': {
    'Cold': [
      'Abominable',
      'Blood Witch',
      'Death Brigadier',
      'Frozen Horror',
      'Reanimated Horde',
      'Serpent Magus'
    ],
    'Lightning': [
      'Fiend',
      'Gloam',
      'Hell Lord',
      'Stygian Harlot'
    ],
    'Physical': [
      'Ghost',
      'Hell Temptress'
    ],
    'Poison': [
      'Blood Temptress',
      'Ghost',
      'Gloam',
      'Serpent Magus',
      'Undead Stygian Doll'
    ]
  },
  'Infernal_Pit': {
    'Cold': [
      'Blood Boss',
      'Hell Witch',
      'Oblivion Knight'
    ],
    'Fire': [
      'Balrog',
      'Blood Lord 2',
      'Consumed Fire Boar',
      'Death Lord',
      'Demon Trickster',
      'Doom Knight',
      'Fire Boar',
      'Tomb Viper'
    ],
    'Lightning': [
      'Night Lord'
    ],
    'Physical': [
      'Blood Lord'
    ],
    'Poison': [
      'Balrog',
      'Reanimated Horde'
    ]
  },
  'Inner_Cloister': {
    'Cold': [
      'Black Archer'
    ],
    'Fire': [
      'Dark One'
    ],
    'Lightning': [
      'Bone Lightning Mage'
    ]
  },
  'Jail': {
    'Fire': [
      'Bone Fire Mage',
      'Dark One'
    ],
    'Lightning': [
      'Bone Lightning Mage',
      'Pitspawn Fouldog',
      'Tainted'
    ],
    'Physical': [
      'Wraith'
    ],
    'Poison': [
      'Bone Archer'
    ]
  },
  'Kurast_Bazaar': {
    'Cold': [
      'Faithful',
      'Sexton',
      'Thrasher'
    ],
    'Fire': [
      'Zakarumite'
    ],
    'Physical': [
      'Hell Swarm'
    ]
  },
  'Kurast_Causeway': {
    'Cold': [
      'Hierophant',
      'Infidel'
    ],
    'Lightning': [
      'Temple Guard',
      'Zealot'
    ]
  },
  'Kurast_Sewers': {
    'Cold': [
      'Gloombat',
      'Icehawk Riftwing'
    ],
    'Magic': [
      'Horadrim Ancient'
    ],
    'Poison': [
      'Feeder',
      'Preserved Dead',
      'Slime Prince',
      'Undead Soul Killer'
    ]
  },
  'Lost_City': {
    'Cold': [
      'Marauder'
    ],
    'Fire': [
      'Tomb Creeper'
    ],
    'Lightning': [
      'Night Tiger'
    ],
    'Magic': [
      'Dark Elder',
      'Plague Bearer'
    ]
  },
  'Lower_Kurast': {
    'Fire': [
      'Hell Buzzard',
      'Zakarumite'
    ],
    'Lightning': [
      'Doom Ape',
      'Tree Lurker'
    ]
  },
  'Lut_Gholein_Sewers': {
    'Fire': [
      'Burning Dead Fire Mage',
      'Burning Dead',
      'Sand Raider'
    ],
    'Poison': [
      'Burning Dead Archer',
      'Dried Corpse'
    ]
  },
  'Maggot_Lair': {
    'Cold': [
      'Coldworm the Burrower'
    ],
    'Lightning': [
      'Death Beetle',
      'Scarab'
    ],
    'Physical': [
      'Black Locusts'
    ],
    'Poison': [
      'Coldworm the Burrower',
      'Rock Worm Egg',
      'Rock Worm Young',
      'Rock Worm',
      'Sand Maggot Young',
      'Sand Maggot'
    ]
  },
  'Matrons_Den': {
    'Cold': [
      'Dark Archer',
      'Flesh Hunter',
      'Vile Witch'
    ],
    'Lightning': [
      'Black Lancer'
    ]
  },
  'Mausoleum': {
    'Lightning': [
      'Hungry Dead',
      'Skeleton'
    ]
  },
  'Monastery_Gate': {
    'Cold': [
      'Dark Stalker'
    ],
    'Lightning': [
      'Disfigured',
      'Returned Lightning Mage'
    ],
    'Poison': [
      'Returned Archer'
    ]
  },
  'Nihlathaks_Temple': {
    'Cold': [
      'Reanimated Horde'
    ],
    'Poison': [
      'Pindleskin',
      'Reanimated Horde'
    ]
  },
  'Outer_Cloister': {
    'Cold': [
      'Black Rogue',
      'Yeti'
    ],
    'Fire': [
      'Devilkin Shaman',
      'Devilkin'
    ]
  },
  'Outer_Steppes': {
    'Cold': [
      'Flesh Beast',
      'Flesh Spawner'
    ],
    'Fire': [
      'Balrog',
      'Doom Knight',
      'Venom Lord'
    ],
    'Lightning': [
      'Cliff Lurker',
      'Doom Caster'
    ],
    'Poison': [
      'Corpulent',
      'Venom Lord'
    ]
  },
  'Palace_Cellar': {
    'Fire': [
      'Blunderbore',
      'Fire Eye',
      'Horror Fire Mage',
      'Invader'
    ],
    'Lightning': [
      'Dune Beast',
      'Horror Lightning Mage'
    ],
    'Poison': [
      'Horror Archer'
    ]
  },
  'Pit': {
    'Cold': [
      'Dark Stalker'
    ],
    'Fire': [
      'Devilkin'
    ],
    'Lightning': [
      'Bone Warrior',
      'Dark Archer'
    ],
    'Poison': [
      'Bone Warrior'
    ]
  },
  'Pit_of_Acheron': {
    'Cold': [
      'Blood Clan',
      'Consumed Ice Boar',
      'Hell Lord',
      'Ice Boar',
      'Overlord'
    ],
    'Fire': [
      'Balrog',
      'Burning Dead Fire Mage',
      'Demon Imp',
      'Tomb Viper'
    ],
    'Lightning': [
      'Night Lord'
    ],
    'Magic': [
      'Unraveler'
    ],
    'Physical': [
      'Blood Lord'
    ],
    'Poison': [
      'Balrog',
      'Burning Dead Fire Mage',
      'Maw Fiend'
    ]
  },
  'Plains_of_Despair': {
    'Cold': [
      'Flesh Beast',
      'Flesh Spawner'
    ],
    'Fire': [
      'Doom Knight',
      'Venom Lord'
    ],
    'Lightning': [
      'Burning Soul',
      'Doom Caster'
    ],
    'Poison': [
      'Corpulent',
      'Venom Lord'
    ]
  },
  'River_of_Flame': {
    'Cold': [
      'Grotesque Wyrm',
      'Grotesque'
    ],
    'Fire': [
      'Pit Lord'
    ],
    'Lightning': [
      'Abyss Knight',
      'Strangler'
    ],
    'Poison': [
      'Blood Maggot Egg',
      'Blood Maggot Young',
      'Blood Maggot',
      'Maw Fiend'
    ]
  },
  'Rocky_Waste': {
    'Cold': [
      'Huntress',
      'Slinger'
    ],
    'Fire': [
      'Sand Leaper'
    ],
    'Lightning': [
      'Dung Soldier'
    ],
    'Poison': [
      'Carrion Bird'
    ]
  },
  'Ruined_Fane': {
    'Cold': [
      'Flesh Archer',
      'Serpent Magus'
    ],
    'Fire': [
      'Blood Diver'
    ],
    'Lightning': [
      'Bone Scarab'
    ]
  },
  'Ruined_Temple': {
    'Cold': [
      'Battlemaid Sarina',
      'Flesh Hunter',
      'Night Lord 2'
    ],
    'Fire': [
      'Spider Magi'
    ],
    'Magic': [
      'Wailing Beast'
    ]
  },
  'Secret_Cow_Level': {
    
  },
  'Spider_Cavern': {
    'Fire': [
      'link= Flame Spider}',
      'Sszark the Burning'
    ],
    'Lightning': [
      'Fiend'
    ],
    'Poison': [
      'Giant Lamprey Young',
      'Giant Lamprey',
      'Poison Spinner'
    ]
  },
  'Spider_Forest': {
    'Cold': [
      'Flesh Beast',
      'Thorned Hulk'
    ],
    'Lightning': [
      'Cloud Stalker',
      'Fetish',
      'Jungle Hunter'
    ],
    'Poison': [
      'Sucker'
    ]
  },
  'Stony_Field': {
    'Cold': [
      'Moon Clan'
    ],
    'Fire': [
      'Carver',
      'Rakanishu'
    ],
    'Lightning': [
      'Dark Ranger',
      'Hungry Dead',
      'Skeleton'
    ],
    'Poison': [
      'Foul Crow'
    ]
  },
  'Stony_Tomb': {
    'Cold': [
      'Creeping Feature'
    ],
    'Lightning': [
      'Burning Dead Lightning Mage',
      'Dung Soldier',
      'Horror'
    ],
    'Poison': [
      'Creeping Feature',
      'Decayed'
    ]
  },
  'Swampy_Pit': {
    'Fire': [
      'Drowned Carcass'
    ],
    'Lightning': [
      'Fiend',
      'Gloam'
    ],
    'Poison': [
      'Preserved Dead',
      'Undead Soul Killer',
      'Undead Stygian Doll'
    ]
  },
  'Tal_Rashas_Chamber': {
    
  },
  'Tal_Rashas_Tomb': {
    'Cold': [
      'Ancient Kaa the Soulless',
      'Ghoul Lord',
      'Gorebelly',
      'Unraveler'
    ],
    'Fire': [
      'Burning Dead'
    ],
    'Lightning': [
      'Steel Scarab'
    ],
    'Magic': [
      'Ancient Kaa the Soulless',
      'Unraveler'
    ],
    'Physical': [
      'Apparition'
    ],
    'Poison': [
      'Preserved Dead'
    ]
  },
  'Tamoe_Highland': {
    'Cold': [
      'Dark Stalker'
    ],
    'Fire': [
      'Returned Fire Mage'
    ],
    'Lightning': [
      'Dark Lancer'
    ],
    'Poison': [
      'Returned Archer'
    ]
  },
  'Ancients_Way': {
    'Cold': [
      'Abominable',
      'Bone Cold Mage',
      'Death Slasher',
      'Frozen Horror',
      'Reanimated Horde',
      'Spike Fiend'
    ],
    'Fire': [
      'Moon Lord',
      'Succubus'
    ],
    'Lightning': [
      'Dark Lancer',
      'Hell Lord',
      'Misshapen'
    ],
    'Poison': [
      'Bone Cold Mage'
    ]
  },
  'Worldstone_Chamber': {
    
  },
  'Throne_of_Destruction': {
    'Cold': [
      'Blood Lord 2',
      'Hell Witch',
      'Oblivion Knight'
    ],
    'Fire': [
      'Balrog',
      'Death Lord',
      'Doom Knight',
      'Invader',
      'Minion of Destruction'
    ],
    'Lightning': [
      'Black Soul'
    ],
    'Magic': [
      'Achmel the Cursed',
      'Hollow One',
      'Unraveler'
    ],
    'Physical': [
      'Stygian Fury'
    ],
    'Poison': [
      'Balrog',
      'Black Soul',
      'Claw Viper',
      'Undead Flayer'
    ]
  },
  'Travincal': {
    'Cold': [
      'Hierophant',
      'Night Lord 2'
    ],
    'Fire': [
      'Council Member'
    ],
    'Lightning': [
      'Council Member',
      'Zealot'
    ]
  },
  'Tristram': {
    'Fire': [
      'Carver Shaman',
      'Carver'
    ],
    'Lightning': [
      'Night Clan'
    ],
    'Poison': [
      'Griswold',
      'Returned',
      'Skeleton Archer'
    ]
  },
  'Underground_Passage': {
    'Cold': [
      'Vile Hunter'
    ],
    'Fire': [
      'Carver'
    ],
    'Lightning': [
      'Misshapen'
    ],
    'Poison': [
      'Skeleton Archer'
    ]
  },
  'Upper_Kurast': {
    'Cold': [
      'Faithful',
      'Thrasher'
    ],
    'Lightning': [
      'Cantor',
      'Winged Nightmare',
      'Zealot'
    ]
  },
  'Valley_of_Snakes': {
    
  },
  'Worldstone_Keep': {
    'Cold': [
      'Blood Boss',
      'Fire Boar',
      'Flesh Beast',
      'Flesh Spawner',
      'Ghoul Lord',
      'Hell Lord',
      'Infidel',
      'Oblivion Knight',
      'Slayer',
      'Vile Witch'
    ],
    'Fire': [
      'Death Lord',
      'Demon Sprite',
      'Doom Knight',
      'Flayer',
      'Hell Spawn',
      'Soul Killer Shaman',
      'Vile Witch'
    ],
    'Lightning': [
      'Black Lancer',
      'Burning Dead Lightning Mage',
      'Desert Wing',
      'Dung Soldier',
      'Gloam',
      'Strangler'
    ],
    'Magic': [
      'Hollow One'
    ],
    'Physical': [
      'Blood Lord',
      'Ghost',
      'Hell Temptress',
      'Stygian Fury'
    ],
    'Poison': [
      'Burning Dead Lightning Mage',
      'Claw Viper',
      'Fetid Defiler',
      'Ghost',
      'Gloam',
      'Preserved Dead',
      'Rancid Defiler',
      'Reanimated Horde',
      'Wretched Defiler'
    ]
  }
}